import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=c5201546&scoped=true&"
import script from "./bottom-navigation.ts?vue&type=script&lang=ts&"
export * from "./bottom-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation.scss?vue&type=style&index=0&id=c5201546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5201546",
  null
  
)

component.options.__file = "bottom-navigation.vue"
export default component.exports